import { Box, Link, Typography } from '@mui/material';
import { FormCheckbox } from 'components/lib/FormCheckbox';
import { FormControl } from 'components/lib/FormControl';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import { PurchaseTypographyAgreementStyle } from 'routes/Purchase/Purchase.styles';
import CheckboxSectionCard from './CheckboxSectionCard';
import type { IPaymentFormikValues } from './CheckoutForm';

interface ElectronicDeliveryCheckboxProps {
  formik: FormikProps<IPaymentFormikValues>;
  isLoading: boolean;
  isAutopayRequired?: boolean;
}

const ElectronicDeliveryCheckbox: FC<ElectronicDeliveryCheckboxProps> = ({
  formik,
  isLoading,
  isAutopayRequired = false,
}) => {
  const checkbox = (
    <FormCheckbox
      id="accept_electronic_delivery"
      data-test="accept_electronic_delivery"
      name="accept_electronic_delivery"
      checked={formik.values.accept_electronic_delivery}
      onChange={formik.handleChange}
      disabled={isLoading}
      labelText={
        <>
          <Typography
            sx={{ textAlign: 'justify', ...PurchaseTypographyAgreementStyle }}
            variant="body2"
          >
            I would like to receive my policy documents{' '}
            <Box component="span" sx={{ fontWeight: 700 }}>
              electronically
            </Box>
            . I agree to the electronic delivery terms.{' '}
            <Box
              component="span"
              sx={{ color: (theme) => theme.palette.customColors.textNeutralTertiary }}
            >
              (Optional)
            </Box>
          </Typography>
          <Typography variant="body2" sx={PurchaseTypographyAgreementStyle}>
            View{' '}
            <Link
              href="/electronic-delivery-consent"
              target="_blank"
              sx={{
                fontWeight: 500,
                color: (theme) => theme.palette.secondary.main,
                textDecorationColor: (theme) => theme.palette.secondary.main,
              }}
            >
              full electronic delivery consent
            </Link>{' '}
            for more details.
          </Typography>
        </>
      }
    />
  );

  return (
    <FormControl sx={{ mb: 6 }}>
      {isAutopayRequired ? (
        <CheckboxSectionCard title="Electronic Delivery">{checkbox}</CheckboxSectionCard>
      ) : (
        checkbox
      )}
    </FormControl>
  );
};

export default ElectronicDeliveryCheckbox;
